import { render, staticRenderFns } from "./user.component.vue?vue&type=template&id=a30a0652&scoped=true"
import script from "./user.component.vue?vue&type=script&lang=ts"
export * from "./user.component.vue?vue&type=script&lang=ts"
import style0 from "../style.scss?vue&type=style&index=0&id=a30a0652&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a30a0652",
  null
  
)

export default component.exports